// extracted by mini-css-extract-plugin
export default {"header":"ProfileHeaderCard_header__u0ZFl","avatar":"ProfileHeaderCard_avatar__h22pz"};